export default function AmiCopyright(parent) {
    var container = <div id="copyright" />;
    parent.appendChild(container);

    return {
        addLine: function(line) {
            var elem = <p />;

            for(var i in line) {
                var section = line[i];
                if(typeof section === 'string')
                    elem.appendChild(document.createTextNode(section));
                else if(Array.isArray(section))
                    elem.appendChild(<a href={section[1]} target="_blank">{section[0]}</a>);
            }

            container.appendChild(elem);
        },
    };
};
